import*as React from'react';import InitialReport from'../classes/InitialReport';import InitialReportPhotoPane from'./InitialReportPhotoPane';import ReportDetailPaneCardItem from'./ReportDetailPaneCardItem';import ReportDetailPaneCardParagrah from'./ReportDetailPaneCardParagrah';var ReportDetailPane=function ReportDetailPane(props){var initialReport=props.currentInitialReport;return<>
      <div className="flow-column mx-0 h-100 overflow-auto">
        <div className="border border-pane-border card m-3 py-2 shadow">
          <ReportDetailPaneCardItem title={initialReport.user.fullName+' ('+initialReport.user.officeName+')'}>
          </ReportDetailPaneCardItem>
          <ReportDetailPaneCardItem title="場所">
            <ReportDetailPaneCardParagrah label="緯度">{initialReport.latitude.toFixed(3)}</ReportDetailPaneCardParagrah>
            <ReportDetailPaneCardParagrah label="経度">{initialReport.longitude.toFixed(3)}</ReportDetailPaneCardParagrah>
            <p className="mb-0">{initialReport.fullAddress}</p>
          </ReportDetailPaneCardItem>
          <ReportDetailPaneCardItem title="揺れの状況">
            <ReportDetailPaneCardParagrah label="揺れの強さ">{initialReport.shakingStrengthText}</ReportDetailPaneCardParagrah>
            <ReportDetailPaneCardParagrah label="揺れの報告">{initialReport.shakingDirectionText}</ReportDetailPaneCardParagrah>
            <ReportDetailPaneCardParagrah label="揺れの時間">{initialReport.shakingTimeText}</ReportDetailPaneCardParagrah>
          </ReportDetailPaneCardItem>
          <ReportDetailPaneCardItem title="屋内の状況">
            <ReportDetailPaneCardParagrah label="周りの建物の状況">{initialReport.surroundingBuildingsDamageText}</ReportDetailPaneCardParagrah>
            <ReportDetailPaneCardParagrah label="火災発生の有無">{initialReport.fireText}</ReportDetailPaneCardParagrah>
            <ReportDetailPaneCardParagrah label="停電の有無">{initialReport.blackoutText}</ReportDetailPaneCardParagrah>
          </ReportDetailPaneCardItem>
          <ReportDetailPaneCardItem title="交通の状況">
            {initialReport.initial_report_traffic_statuses.map(function(trafficStatus,i){return<div key={trafficStatus.id}className={"mb-".concat(i===initialReport.initial_report_traffic_statuses.length-1?0:2)}>
                  <p className="mb-1">{InitialReport.trafficStatusCategoryText(trafficStatus.category)}</p>
                  <div className="ml-3">
                    <p className="mb-0 text-prewrap">{trafficStatus.route}</p>
                    <p className="mb-0 text-prewrap">{trafficStatus.status}</p>
                  </div>
                </div>;})}
          </ReportDetailPaneCardItem>
          <ReportDetailPaneCardItem title="庁舎・宿舎の状況">
            <ReportDetailPaneCardParagrah label="庁舎の状況">{initialReport.governmentBuildingDamageText}</ReportDetailPaneCardParagrah>
            <ReportDetailPaneCardParagrah label="宿舎の状況">{initialReport.lodgingHouseDamageText}</ReportDetailPaneCardParagrah>
          </ReportDetailPaneCardItem>
          <ReportDetailPaneCardItem title="その他">
            <div className="mb-2">
              <p className="mb-0">その他</p>
              <p className="mb-0">{initialReport.other_serious_damage||'----'}</p>
            </div>
            <div>
              <p className="mb-0">自由記入欄</p>
              <p className="mb-0">{initialReport.free_entry||'----'}</p>
            </div>
          </ReportDetailPaneCardItem>
        </div>
        <div className="border border-pane-border card m-3 shadow">
          <InitialReportPhotoPane onSelectPhoto={props.onSelectPhoto}initialReportPhotos={initialReport.initial_report_photos}/>
        </div>
      </div>
    </>;};export default ReportDetailPane;